var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.layout,{tag:"component",class:_vm.layoutClass,attrs:{"id":"app"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }